
import { Poll } from '@/types/poll';
import { usePollActivation } from './actions/usePollActivation';
import { usePollClosure } from './actions/usePollClosure';
import { usePollReopening } from './actions/usePollReopening';

export const usePollStatus = (
  polls: Poll[], 
  setPolls: React.Dispatch<React.SetStateAction<Poll[]>>
) => {
  const { handleActivatePoll, isProcessing: isActivating } = usePollActivation(polls, setPolls);
  
  // Create handleClosePoll wrapper around closePoll
  const { closePoll, isClosing } = usePollClosure();
  const handleClosePoll = async (pollId: string) => {
    const poll = polls.find(p => p.id === pollId);
    if (!poll) {
      console.error('Poll not found:', pollId);
      return false;
    }
    
    console.log('Handling poll closure for poll:', poll);
    const success = await closePoll(pollId, poll);
    
    if (success) {
      // Update local state to reflect the change
      setPolls(prev => prev.map(p => 
        p.id === pollId ? { ...p, status: 'closed' } : p
      ));
    }
    
    return success;
  };
  
  const { handleReopenPoll, isProcessing: isReopening } = usePollReopening(polls, setPolls);

  const isProcessing = isActivating || isClosing || isReopening;

  return {
    handleActivatePoll,
    handleClosePoll,
    handleReopenPoll,
    isProcessing
  };
};
